import { render, staticRenderFns } from "./NewSancion.vue?vue&type=template&id=01abb129&"
import script from "./NewSancion.vue?vue&type=script&lang=js&"
export * from "./NewSancion.vue?vue&type=script&lang=js&"
import style0 from "./NewSancion.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports